import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import EditorialMarquee from "./components/Marquee";
import MenuSection from "./components/MenuSection";
import PinsaSection from "./components/PinsaSection";
import OrderCTA from "./components/OrderCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import StaffPage from "./pages/StaffPage";

function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 25 });
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed inset-x-0 top-0 z-[60] h-1 origin-left bg-ember"
      style={{ scaleX }}
    />
  );
}

function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <MenuSection />
        <PinsaSection />
        <OrderCTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <div className="bg-cream text-charcoal">
          <ScrollProgress />
          <div className="grain-overlay" aria-hidden />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/staff" element={<StaffPage />} />
          </Routes>
          <CartDrawer />
          <Toaster
            position="bottom-center"
            toastOptions={{ style: { background: "#18181B", color: "#F9F6F0", border: "1px solid rgba(249,246,240,0.15)" } }}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
